import CounselorRequestModel from './CounselorRequestModel';

export default class RecommendedActionModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.recommended_action = data.recommended_action || ''; // no_recommendation
    // for now not using this here this.recommended_counselor = data.recommended_counselor ? new CounselorRequestModel(data.recommended_counselor) : null;
    this.recommended_counselor = null;
  }


  get hasFreeIndividual() {
    return this.recommended_action === 'free_individual_session';
  }

  get hasFreeGroup() {
    return this.recommended_action === 'free_group_session';
  }

  get hasFreeConsult() {
    return this.recommended_action === 'free_initial_consultation';
  }
}
